// Teaching experience options for tutor onboarding
export const TEACHING_EXPERIENCES = [
  { id: "classroom", label: "Classroom Teaching" },
  { id: "online", label: "Online Tutoring" },
  { id: "private", label: "Private Tutoring" },
  { id: "curriculum", label: "Curriculum Development" },
  { id: "assessment", label: "Assessment Design" },
  { id: "none", label: "No Prior Experience" },
]; 